import PropTypes from 'prop-types';

export const DialogBodyPropTypes = {
  classes: PropTypes.object,
  errors: PropTypes.arrayOf(PropTypes.string),
  onClick: PropTypes.func,
  onClose: PropTypes.func,
  label: PropTypes.string,
  onSecondaryClick: PropTypes.func,
  secondaryLabel: PropTypes.string
};

export const ErrorDialogPropTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  ...DialogBodyPropTypes
};
